export const letterScaleAnimDuration = 100;

export const LSKeys = {
    guesses: 'guesses',
    day: 'day',
    localStats: 'local stats',
    correctWords: 'correct words',
    gameNumber: 'game number',
    uid: 'uid',
    hasSeenHelp: 'has seen help',
    hasSeenShareInfo: 'has seen share info',
    colorBlind: 'is color blind on',
}